import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { HStack, Icon, SectionHeader, theme } from '@sg/garnish';

/**
 * The four credit card icons that indicate a payment block.
 */
export const PaymentBlockCardIcons = () => {
  const { formatMessage } = useIntl();
  const heading = formatMessage(messages.paymentMethod);

  return (
    <SectionHeader heading={heading}>
      <View style={styles.iconsWrapper}>
        <HStack gap={8}>
          <Icon name="IconCcVisa" color={theme.colors.POTATO} />
          <Icon name="IconCcMasterCard" color={theme.colors.POTATO} />
          <Icon name="IconCcDiscover" color={theme.colors.POTATO} />
          <Icon name="IconCcAmex" color={theme.colors.POTATO} />
        </HStack>
      </View>
    </SectionHeader>
  );
};

const styles = StyleSheet.create({
  iconsWrapper: {
    marginLeft: 'auto',
    paddingLeft: theme.spacing['2'],
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  paymentMethod: {
    defaultMessage: 'Payment method',
    description: 'Payment Block Card Icons | Payment Method',
  },
});
